import smallLoader from "@/assets/animations/small-loader.json";
import LoaderBase, {
  LoaderPropsBase,
} from "@/components/common/base/loader-base";

const SmallLoader = ({ size }: LoaderPropsBase) => {
  return <LoaderBase source={smallLoader} size={size} />;
};

export default SmallLoader;
